import { baseApi } from "@/services/api/baseApi";

export const quizApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChats: builder.query({
      query: ({ page, itemsPerPage, search }) =>
        `messages?page=${page}&search=${search}&per_page=${itemsPerPage}`,
      providesTags: ["Chats"],
    }),
    createChat: builder.mutation({
      query: (payload) => ({
        url: "messages",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Chats"],
    }),
    getChatById: builder.query({
      query: (id) => `messages/${id}`,
      providesTags: (result, error, id) => [{ type: "Chats", id }],
    }),
    getNotifications: builder.query({
      query: (is_unread) =>
        `notifications${is_unread ? `?is_unread=${is_unread}` : ""}`,
      providesTags: (result, error, id) => [{ type: "Notifications", id }],
    }),
    createReply: builder.mutation({
      query: ({ id, formData }) => ({
        url: `messages/${id}/reply`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Chats", id }],
    }),
    postMarkAsSolved: builder.mutation({
      query: (formData) => ({
        url: `messages/mark-as-solved`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Chats", id }],
    }),
    postMarkAsRead: builder.mutation({
      query: (notificationData) => ({
        url: `notifications/mark-as-read`,
        method: "PATCH",
        body: notificationData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Notifications", id },
      ],
    }),
  }),
});

export const {
  useCreateChatMutation,
  useGetChatsQuery,
  useLazyGetChatsQuery,
  useGetChatByIdQuery,
  useCreateReplyMutation,
  usePostMarkAsSolvedMutation,
  usePostMarkAsReadMutation,
  useGetNotificationsQuery,
} = quizApi;
